import React from "react";
import { usePrefixContext } from '../context/PrefixContext';
import { useTranslation } from 'react-i18next';

import img_ft_close from "../Images/ft_close.gif";

export default function BoxStep(props) {
  const { stepData , removeBet } = props;
  const { prefix } = usePrefixContext();
  const { t } = useTranslation();

  var price_data = {};

  if (stepData.id_type_num === 1 && stepData.BetHF === 2) {
    if (stepData.BetType === "home") {
      price_data["BetPlay"] = (
        <span className={stepData.IsHomeGive === true ? "txtBetRedBold" : "txtBetBlueBold"}>
          {stepData.Home}
        </span>
      );
    } else {
      price_data["BetPlay"] = (
        <span className={stepData.IsHomeGive === false ? "txtBetRedBold" : "txtBetBlueBold"}>
          {stepData.Away}
        </span>
      );
    }
    price_data["title_bet"] = t("BetBox_"+prefix.sport_list[stepData.Zone], { defaultValue: t(prefix.sport_list[stepData.Zone]) })+" / "+t("BetBox_Handicap");
  } else if (stepData.id_type_num === 2 && stepData.BetHF === 2) {
    if (stepData.BetType === "home") {
      price_data["BetPlay"] = <span className="txtBet">{t("BetBox_over")}</span>;
    } else {
      price_data["BetPlay"] = <span className="txtBet">{t("BetBox_under")}</span>;
    }
    price_data["title_bet"] = t("BetBox_"+prefix.sport_list[stepData.Zone], { defaultValue: t(prefix.sport_list[stepData.Zone]) })+" / "+t("BetBox_Over_Under");
  } else if (stepData.id_type_num === 3 && stepData.BetHF === 2) {
    if (stepData.BetType === "home") {
      price_data["BetPlay"] = (
        <>
          <span className="txtBet">{stepData.Home}</span>&nbsp;&nbsp;&nbsp;
          <span className="txtBetBlueBold">{t("BetBox_full_Time")}.1</span>
        </>
      );
    } else if (stepData.BetType === "away") {
      price_data["BetPlay"] = (
        <>
          <span className="txtBet">{stepData.Away}</span>&nbsp;&nbsp;&nbsp;
          <span className="txtBetBlueBold">{t("BetBox_full_Time")}.2</span>
        </>
      );
    } else {
      price_data["BetPlay"] = (
        <>
          <span className="txtBet">{stepData.Home}</span>&nbsp;&nbsp;&nbsp;
          <span className="txtBetBlueBold">{t("BetBox_full_Time")}.X</span>
        </>
      );
    }
    price_data["title_bet"] = t("BetBox_"+prefix.sport_list[stepData.Zone], { defaultValue: t(prefix.sport_list[stepData.Zone]) })+" / 1X2";
  } else if (stepData.id_type_num === 4 && stepData.BetHF === 2) {
    if (stepData.BetType === "odd") {
      price_data["BetPlay"] = <span className="txtBet">{t("BetBox_odd")}</span>;
    } else {
      price_data["BetPlay"] = <span className="txtBet">{t("BetBox_even")}</span>;
    }
    price_data["title_bet"] = t("BetBox_"+prefix.sport_list[stepData.Zone], { defaultValue: t(prefix.sport_list[stepData.Zone]) })+" / "+t("BetBox_Odd_Even");
  } else if (stepData.id_type_num === 5 && stepData.BetHF === 1) {
    if (stepData.BetType === "home") {
      price_data["BetPlay"] = (
        <span className={stepData.IsHomeGive === true ? "txtBetRedBold" : "txtBetBlueBold"}>
          {stepData.Home}
        </span>
      );
    } else {
      price_data["BetPlay"] = (
        <span className={stepData.IsHomeGive === false ? "txtBetRedBold" : "txtBetBlueBold"}>
          {stepData.Away}
        </span>
      );
    }
    price_data["title_bet"] = t("BetBox_"+prefix.sport_list[stepData.Zone], { defaultValue: t(prefix.sport_list[stepData.Zone]) })+" / "+t("BetBox_first_Half")+" "+t("BetBox_Handicap");
  } else if (stepData.id_type_num === 6 && stepData.BetHF === 1) {
    if (stepData.BetType === "home") {
      price_data["BetPlay"] = <span className="txtBet">{t("BetBox_over")}</span>;
    } else {
      price_data["BetPlay"] = <span className="txtBet">{t("BetBox_under")}</span>;
    }

    price_data["title_bet"] = t("BetBox_"+prefix.sport_list[stepData.Zone], { defaultValue: t(prefix.sport_list[stepData.Zone]) })+" / "+t("BetBox_first_Half")+" "+t("BetBox_Over_Under");
  } else if (stepData.id_type_num === 7 && stepData.BetHF === 1) {
    if (stepData.BetType === "home") {
      price_data["BetPlay"] = (
        <>
          <span className="txtBet">{stepData.Home}</span>&nbsp;&nbsp;&nbsp;
          <span className="txtBetBlueBold">{t("BetBox_first_Half")}.1</span>
        </>
      );
    } else if (stepData.BetType === "away") {
      price_data["BetPlay"] = (
        <>
          <span className="txtBet">{stepData.Away}</span>&nbsp;&nbsp;&nbsp;
          <span className="txtBetBlueBold">{t("BetBox_first_Half")}.2</span>
        </>
      );
    } else {
      price_data["BetPlay"] = (
        <>
          <span className="txtBet">{stepData.Home}</span>&nbsp;&nbsp;&nbsp;
          <span className="txtBetBlueBold">{t("BetBox_first_Half")}.X</span>
        </>
      );
    }

    price_data["title_bet"] = t("BetBox_"+prefix.sport_list[stepData.Zone], { defaultValue: t(prefix.sport_list[stepData.Zone]) })+" / "+t("BetBox_first_Half")+" 1X2";
  } else if (stepData.id_type_num === 8 && stepData.BetHF === 1) {
    if (stepData.BetType === "odd") {
      price_data["BetPlay"] = <span className="txtBet">{t("BetBox_odd")}</span>;
    } else {
      price_data["BetPlay"] = <span className="txtBet">{t("BetBox_even")}</span>;
    }
    price_data["title_bet"] = t("BetBox_"+prefix.sport_list[stepData.Zone], { defaultValue: t(prefix.sport_list[stepData.Zone]) })+" / "+t("BetBox_first_Half")+" "+t("BetBox_Odd_Even");
  }

  var showBlink = 0;
  var now_t = new Date();
  var d_time = getMinutesBetweenDates(stepData.betBlink, now_t);
  if(d_time<7){
    showBlink = 1;
  }else{
    showBlink = 0;
  }

  return (
    <div
      className={(stepData.IsRun === true ? "GridRunItemBet" : "GridItemBet")+(stepData.betStatus !== 1 ? " BetBoxBlink" : "")}
      style={{
        display: "inline-block",
        width: "100%",
        height: "100%",
        padding: "3px 5px 7px 5px",
        boxSizing: "border-box",
        lineHeight: "1.4",
      }}
    >
      <div
        style={{
          display: "inline-block",
          width: "100%",
          height: "100%",
        }}
      >
        <div
          className={stepData.IsRun === true ? "title-R" : "title-T"}
          style={{
            textAlign: "left",
            float: "left",
            fontWeight: "bold",
            width: "90%",
          }}
        >
          {price_data["title_bet"]}
        </div>
        <div
          style={{
            display: "inline-block",
            textAlign: "right",
            width: "10%",
          }}
        >
          <img
            id="btnDelete"
            src={img_ft_close}
            width="14px"
            height="14px"
            alt=""
            border={0}
            style={{ cursor: "pointer" }}
            onClick={() => removeBet(stepData)}
          />
        </div>
      </div>
      <div
        className="txtBetBold border-R"
        style={{
          display: "inline-block",
          textAlign: "left",
          width: "95%",
          paddingLeft: 3,
        }}
      >
        {price_data["BetPlay"]}
        <br />
        {((stepData.IsHomeGive === true && stepData.BetType === "home" && stepData.BetHdp !== "0") || (stepData.IsHomeGive === false && stepData.BetType === "away" && stepData.BetHdp !== "0" && stepData.BetHdp !== "") ? "-" : "")+stepData.BetHdp}&nbsp;
        <span style={{ color: "#666666", fontWeight: "normal" }}>{stepData.IsRun === true ? "["+stepData.Score+"]" : ""}</span>
        &nbsp;@&nbsp;&nbsp;
        <label className={(showBlink===1 ? "OddsChgBlink" : "")}>
        {stepData.BetOdds}
        </label>
      </div>
      <div style={{ color: "#666666", textAlign: "left" }}>
        {stepData.Home}
      </div>
      <div style={{ color: "#666666", textAlign: "left" }}>
        {stepData.Away}
      </div>
      {stepData.betStatus !== 1 ? <div style={{textAlign: 'left', color: 'red', fontSize: 9}}>{t("BetBox_Price_not_available_for_this_match")}</div> : null}
    </div>
  );
}
function getMinutesBetweenDates(startDate, endDate) {
    var diffMs = endDate - startDate;
    var diffSec = diffMs / 1000;
    return diffSec;
  }
